import React from "react";
const ProtectedRoute = ({ children, allowedRoles, userRole }: any) => {
  const isAuthorized = allowedRoles?.includes(userRole);
  return isAuthorized ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <h1 className="flex justify-center items-center">You are not authorize</h1>
  );
};

export default ProtectedRoute;
